"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PageHeaderColorScheme = void 0;
let PageHeaderColorScheme = exports.PageHeaderColorScheme = /*#__PURE__*/function (PageHeaderColorScheme) {
  PageHeaderColorScheme["Default"] = "default";
  PageHeaderColorScheme["Inverted"] = "inverted";
  return PageHeaderColorScheme;
}({}); // TODO: Update in 4.x, PageHeaderDropdownButton does not support all Button props
// Check which props are valid in PageHeaderDropdownButton propTypes.
// eslint-disable-next-line @typescript-eslint/no-empty-interface